import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
import { auth } from '../../services/api';
import { setUser } from '../../store/userSlice';
import styled from 'styled-components';

const ForgotPasswordLink = styled.a`
  float: right;
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
  &:hover {
    color: #40a9ff;
  }
`;

interface LoginFormProps {
  onSuccess?: () => void;
  onForgotPassword?: () => void;
  onSwitchToRegister?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  onSuccess,
  onForgotPassword,
  onSwitchToRegister
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values: any) => {
    try {
      setLoading(true);
      const response = await auth.login(values.email, values.password);
      const user = await auth.getCurrentUser();
      dispatch(setUser(user));
      message.success('登录成功');
      onSuccess?.();
    } catch (error: any) {
      if (error.response?.status === 401) {
        message.error(error.response?.data?.detail || '登录失败：邮箱或密码错误');
      } else if (error.response?.status === 403) {
        message.error(error.response?.data?.detail || '账号未激活：请先验证邮箱');
        // 显示重新发送验证邮件的按钮
        form.setFields([
          {
            name: 'email',
            errors: ['请先验证邮箱后再登录。如未收到验证邮件，可以重新发送。']
          }
        ]);
      } else {
        message.error(error.response?.data?.detail || '登录失败，请稍后重试');
      }
      // 清空密码字段
      form.setFields([
        {
          name: 'password',
          value: ''
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPasswordClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // 切换前移除焦点
    document.activeElement instanceof HTMLElement && document.activeElement.blur();
    onForgotPassword?.();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleLogin}
      preserve={false}
      onFinishFailed={({ errorFields }) => {
        form.scrollToField(errorFields[0].name);
      }}
    >
      <Form.Item
        name="email"
        label="邮箱"
        rules={[
          { required: true, message: '请输入邮箱' },
          { type: 'email', message: '请输入有效的邮箱地址' }
        ]}
      >
        <Input placeholder="请输入邮箱" />
      </Form.Item>
      
      <Form.Item
        name="password"
        label="密码"
        rules={[{ required: true, message: '请输入密码' }]}
      >
        <Input.Password placeholder="请输入密码" />
      </Form.Item>
      
      <Form.Item>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button 
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            登录
          </Button>
          <ForgotPasswordLink 
            onClick={handleForgotPasswordClick}
            onKeyPress={(e) => e.key === 'Enter' && onForgotPassword?.()}
            tabIndex={0}
          >
            忘记密码？
          </ForgotPasswordLink>
        </div>
      </Form.Item>

      <div style={{ textAlign: 'center', marginTop: '16px' }}>
        <span style={{ color: '#8c8c8c' }}>还没有账号？</span>
        {' '}
        <Button type="link" onClick={onSwitchToRegister} style={{ padding: '0 4px' }}>
          立即注册
        </Button>
      </div>
    </Form>
  );
};

export default LoginForm; 